export const PROJECTED_GROWTH_CONFIG = {
	plotOptions: {
		spline: {
			marker: {
				enabled: false,
				symbol: 'circle',
				states: {
					hover: {
						enabled: true,
						lineColor: '#FFFFFF',
						lineWidth: 1
					}
				}
			},
			states: {
				inactive: {
					enabled: false
				},
				hover: {
					lineWidthPlus: 0,
					halo: {
						size: 0
					}
				}
			}
		},
		areasplinerange: {
			lineWidth: 0,
			marker: {
				enabled: false,
				states: {
					hover: {
						enabled: false
					}
				}
			},
			states: {
				inactive: {
					enabled: false
				},
				hover: {
					enabled: false
				}
			}
		}
	},
	xAxis: {
		type: 'datetime',
		labels: {
			formatter: function (): any {
				const date = new Date(this.value);
				return (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getDate().toString().padStart(2, '0') + '/' + date.getFullYear().toString();
			}
		},
		// This empty object is necessary for the crosshair to appear
		crosshair: {
		}
	},
	yAxis: {
		labels: {
			formatter: function (): any {
				return '$' + this.value.toLocaleString({ minimumFractionDigits: 0, maximumFractionDigits: 0 });
			}
		},
		title: undefined
	},
	tooltip: {
		shared: true,
		useHTML: true,
		shape: 'callout',
		borderWidth: 0,
		shadow: true,
		backgroundColor: '#FFFFFFE6'

	},
	legend: {
		enabled: true,
		align: 'left'
	}
};
